module.exports = __webpack_public_path__ + "img/living-sheer-blinds.5eb646db.webp";